import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, Button } from 'react-bootstrap';

class WarningModal extends Component {
  constructor() {
    super();
    this.state = {};
    this.close = this.close.bind(this);
    this.confirm = this.confirm.bind(this);
  }
  close() {
    this.props.onClose();
  }
  confirm() {
    const { program } = this.props;
    this.props.onConfirm(program);
  }

  render() {
    const { opportunities, isOpen, program } = this.props;
    const shouldOpen = program && isOpen && opportunities.length > 0;

    return (
      <Modal show={shouldOpen} onHide={this.close} bsSize="lg">
        <Modal.Body>
          {program !== null && <div className="well well-sm">
            The below <code>edited values</code> are not compatible with the requested program <strong>{program.name} (client: {program.client_name})</strong>.<br />
            Are you sure you want to reset all <code>below values</code> before switching to a new program?
          </div>}
          <div style={{ maxHeight: 400, overflow: 'auto' }}>
            <ul>
              {opportunities.map((opportunity, i) => (
                <li key={i}>
                  <div>
                    <strong>{opportunity.name}</strong>
                    {opportunity.account != undefined && <span>({opportunity.account.name})</span>}
                  </div>
                  <ul>
                    <li>
                      {opportunity.selected_contacts.length === 1 && <div>Selected Contact:</div>}
                      {opportunity.selected_contacts.length !== 1 && <div>Selected Contacts:</div>}
                      <ul>
                        {opportunity.selected_contacts.map(contact => (
                          <li key={contact.contact_id}>
                            <div><strong>{contact.first_name} {contact.last_name}</strong> ({contact.email})</div>
                            <ul>
                              {contact.buyer_role !== null && <li>Buyer Role: <code>{contact.buyer_role}</code></li>}
                              {contact.buyer_type !== null && <li>Buyer Type: <code>{contact.buyer_type}</code></li>}
                              {contact.tags.length > 0 && <li>
                                      Opportunity Tags:
                                <ul>
                                  {contact.tags.map((tag, i) => (
                                    <li key={i}><code>{tag}</code></li>
                                          ))}
                                </ul>
                                                          </li>}
                            </ul>
                          </li>
                            ))}
                      </ul>
                    </li>
                  </ul>
                </li>
                ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-xs-6">
              <div className="pull-left">
                <Button bsStyle="link" onClick={this.close}>Cancel</Button>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="pull-right">
                <Button bsStyle="primary" type="submit" onClick={this.confirm}>Reset</Button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

WarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  opportunities: PropTypes.array,
  program: PropTypes.object,
};
WarningModal.defaultProps = {
  onClose: () => {},
  onConfirm: () => {},
};
export default WarningModal;
